import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { disclaimerRequest } from '../../shared/models/Flow';
import { AdminService } from '../admin.service';
import { Content, Document } from '../../shared/models/content';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manage-documents',
  templateUrl: './manage-documents.component.html',
  styleUrls: ['./manage-documents.component.scss']
})
export class ManageDocumentsComponent implements OnInit {

  public imageSrc = '';
  public filename = '';
  public fileDisplayname = '';
  public icon = '';
  public type: string;
  public contents: Content[];
  public file: File;
  public displayedColumns: string[] = [];
  public documentsDataSource = new MatTableDataSource([]);
  public hasPermission = false ;
  public documentGroup: any[];

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  constructor(
    private adminService: AdminService, public commonService: TCCPCommonService, private dialog: MatDialog) {
    this.displayedColumns = ['fileDisplayName', 'uploadedTime', 'uploadedBy', 'edit' , 'delete'];
  }

  ngOnInit() {
    this.getAllContents();
  }

  getDocURL(currDoc) {
    const baseUrl = environment.baseURL;
    return (baseUrl + currDoc.path);
  }

  getAllContents() {
    this.adminService.getAllDocuments().subscribe((response: any) => {
      if (response) {
        this.contents = response;
        const contents = [];
        let sortedContents = [];
        this.documentGroup = response.map(x => x.document);
        this.documentGroup = this.documentGroup.filter((n, i) => this.documentGroup.indexOf(n) === i).sort((a, b) => a > b ? 1 : -1);
        this.contents.forEach((contentData, index) => {
          const obj = {
            contentId: contentData.contentId,
            fileDisplayName: contentData.document.fileDisplayName,
            documentId: index + 1,
            uploadedBy: contentData.uploadedBy,
            uploadedTime: contentData.uploadedTime,
            path : contentData.document.path,
            displayName : contentData.document.displayName,
            description : contentData.document.description,
            keywords: contentData.document.searchKeywords,
            quickLinks: contentData.document.quickLnks
          };
          contents.push(obj);
        });

        sortedContents = contents.sort((obj1, obj2) => {
          return obj1.uploadedTime - obj2.uploadedTime;
        });

        this.contents = contents.sort((obj1, obj2) => {
          return obj1.uploadedTime - obj2.uploadedTime;
        });

        this.documentsDataSource.data = sortedContents;
        setTimeout(() => {
          this.documentsDataSource.sort = this.sort;
          this.documentsDataSource.paginator = this.paginator;
        });
      }
    });
  }

  applyFilter(filterValue: string) {
    this.documentsDataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteDocument(content: Content) {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: 'Are you sure you want to delete the Document?',
      position: { top: '100px' }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteContent(content.contentId);
      }
    });
  }

  editDocument(contentObj: Document) {
    this.getAllContents();
    const dialogRef = this.dialog.open(AddDocumentDialogComponent, {
      width: '500px',
      data: { documentGroup: this.documentGroup, content: contentObj },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getAllContents();
      }
    });
  }

  deleteContent(id: string) {
    this.adminService.deleteContentById(id).subscribe(data => {
      this.getAllContents();
    });
  }

  openAddDocumentDialog(): void {
    const dialogRef = this.dialog.open(AddDocumentDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event && result.event === 'save') {
        this.getAllContents();
      }
    });
  }
}

@Component({
  selector: 'app-add-document-dialog-component',
  templateUrl: './add-document-dialog.html',
  styleUrls: ['./manage-documents.component.scss']

})
export class AddDocumentDialogComponent implements OnInit {
  public alerts: any[] = [];
  public imageSrc = '';
  public filename = '';
  public icon = '';
  public type: string;
  public thumbnilPath = '';
  public fileDisplayname = '';
  public contents: Content[];
  public documentName = '';
  public documentDisplayName = '';
  public documentDescription = '';
  public documentSearchKeywords = '';
  public documentPath = '';
  public quickLinks = '';
  public documentContent: Content = <Content> {};
  public theme: string = null;
  public content: Content = <Content> { document: <Document> {} };
  constructor(
    public dialogRef: MatDialogRef<ManageDocumentsComponent>, public authService: MsalService,
    private adminService: AdminService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.getAllContents();
  }

  ngOnInit() {
    this.theme = environment.applicationName + '-' + this.adminService.selectedApplication;
    this.thumbnilPath = TCCPConstantValues.admin.Urls.IMAGE_PATH;
    if (this.data) {
      this.content = JSON.parse(JSON.stringify(this.data.content));
      this.documentName = _.get(this.content , 'path');
      this.documentDisplayName = _.get(this.content , 'fileDisplayName');
      this.documentDescription = _.get(this.content , 'description');
      this.documentSearchKeywords = _.get(this.content , 'keywords');
      this.quickLinks = _.get(this.content , 'quickLinks');
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  uploadFiles() {
    const element: HTMLElement = document.getElementsByClassName('addDocumentUploader')[0] as HTMLElement;
    element.click();
  }

  onFileChange(files: FileList) {
    const ext = files[0].name.split('.').pop();
    this.fileDisplayname = files[0].name;
    this.filename = files[0].name.replace('.' + ext, new Date().toISOString() + '.' + ext);
    if (files[0].name !== '') {
      const fileRequestBody = new disclaimerRequest();
      fileRequestBody.source = this.adminService.selectedApplication;
      fileRequestBody.contentType = files[0].type;
      fileRequestBody.fileName = this.filename;
      fileRequestBody.fileDisplayName = files[0].name;
      fileRequestBody.contentBase64 = null;
      this.documentName = this.filename;
      this.documentDisplayName = files[0].name;
      this.adminService.uploadImage(fileRequestBody).subscribe((response: any) => {
        if (response) {
          this.uploadtoS3(files[0], response.url, files[0].type, response.path);
        }
      });
    }
  }

  uploadtoS3(fileRequest: File, response: string, type: string, path) {
    this.adminService.uploadtoS3(fileRequest, response, type).subscribe((fileresponse: any) => {
      this.updateDocument(path, this.filename, this.fileDisplayname);
    });
  }

  updateDocument(path: string, fileName: string, fileDisplayName: string) {
    const document: Document = <Document> {};
    const contents: Content = <Content> {};
    document.fileDisplayName = fileDisplayName;
    document.fileName = encodeURIComponent(fileName);
    document.path = path;
    this.documentPath = path;
    let id = 0;
    if (this.contents.length === 0) {
      id = 1;
    } else {
      id = this.contents[this.contents.length - 1]['document']['documentId'] + 1;
    }
    this.documentContent.document = document;
    this.documentContent.document.path = path;
    this.documentContent.contentId = null;
    this.documentContent.contentType = 'document';
    this.documentContent.division = this.adminService.selectedApplication;
    this.documentContent.document.documentId = id;
    this.documentContent.uploadedTime = new Date();
    this.documentContent.uploadedBy = this.authService.instance.getActiveAccount().username;
  }
  getAllContents() {
    let contents = [];
    this.adminService.getAllDocuments().subscribe((response: any) => {
      if (response) {
        contents = response;
        this.contents = contents.sort((obj1, obj2) => {
          return obj1.document.documentId - obj2.document.documentId;
        });
      }
    });
  }

  onSelect() {
    let isValid = false ;
    if (!this.documentDisplayName) {
      this.showAlertMessages('error', TCCPConstantValues.admin.messages.DISPLAYNAME_ERROR_MESSAGE);
      isValid = false ;
    } else {
      isValid = true;
    }
    if (isValid) {
      if (_.isUndefined(this.content.contentId)) {
        const path = this.documentPath;
        const document: Document = <Document>{};
        this.documentContent.document = document;
        this.documentContent.document.path = path;
        this.documentContent.contentId = this.content.contentId;
        this.documentContent.document.fileDisplayName = this.documentDisplayName;
        this.documentContent.division = this.adminService.selectedApplication;
        this.documentContent.document.displayName = this.documentName;
        this.documentContent.document.description = this.documentDescription;
        this.documentContent.document.fileDisplayName = this.documentDisplayName;
        this.documentContent.document.searchKeywords = this.documentSearchKeywords.replace(/,\s*$/, "");
        this.documentContent.document.quickLnks = this.quickLinks;
        this.documentContent.contentType = 'document';
        this.documentContent.uploadedTime = new Date();
        this.documentContent.uploadedBy = this.authService.instance.getActiveAccount().username;

      }

      if (_.isUndefined(this.content.contentId)) {
        this.adminService.insertdocument(this.documentContent).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
          }
        });
      } else {
        const path = _.get(this.content, 'path');
        const document: Document = <Document> {};
        this.documentContent.document = document;
        this.documentContent.document.path = path;
        this.documentContent.contentId = this.content.contentId;
        this.documentContent.document.fileDisplayName = this.documentDisplayName;
        this.documentContent.division = this.adminService.selectedApplication;
        this.documentContent.document.displayName = this.documentName;
        this.documentContent.document.description = this.documentDescription;
        this.documentContent.document.fileDisplayName = this.documentDisplayName;
        this.documentContent.document.searchKeywords = this.documentSearchKeywords.replace(/,\s*$/, "");
        this.documentContent.document.quickLnks = this.quickLinks;
        this.documentContent.contentType = 'document';
        this.documentContent.uploadedTime = new Date();
        this.documentContent.uploadedBy = this.authService.instance.getActiveAccount().username;

        this.adminService.updateSupportContent(this.documentContent).subscribe((response: any) => {
          if (response) {
            this.dialogRef.close({ event: 'save' });
          }
        });
      }

    }
  }

  onCancel() {
    this.dialogRef.close();
  }

}
